import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon, StarIcon } from 'lucide-react';
import { checkoutUrl, handleCheckoutClick } from '../utils/checkout';
import { FinalOffer } from './FinalOffer';
const testimonials = [{
  name: 'Andrea P.',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=240&q=80',
  quote: 'El domingo comí pastel y no pasó nada. Dejar la culpa fue lo que más me cambió.'
}, {
  name: 'Carolina M.',
  image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=240&q=80',
  quote: 'Dejo la semana lista el domingo. Ya no llego a casa a improvisar con lo que haya.'
}, {
  name: 'Daniela R.',
  image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=240&q=80',
  quote: 'Me sorprendió no aburrirme. Siempre hay algo distinto que se me antoja preparar.'
}, {
  name: 'Paola G.',
  image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=240&q=80',
  quote: 'No tuve que comprar nada raro. Empecé con lo que ya tenía en casa.'
}, {
  name: 'María C.',
  image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=240&q=80',
  quote: 'Volví a disfrutar la comida. Ahora cocino con ganas, no por obligación.'
}, {
  name: 'Valentina A.',
  image: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?auto=format&fit=crop&w=240&q=80',
  quote: 'Creía que cuidarme era sufrir. Resultó ser la parte más tranquila de mi día.'
}, {
  name: 'Sofía T.',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=240&q=80',
  quote: 'Llevaba años empezando los lunes. Esta vez ya llevo meses sin dejarlo.'
}, {
  name: 'Laura V.',
  image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=240&q=80',
  quote: 'Nunca supe cocinar. Ahora preparo cosas ricas sin ponerme nerviosa.'
}, {
  name: 'Gabriela N.',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=240&q=80',
  quote: 'Se acabaron las mil capturas en el teléfono. Todo está en un mismo lugar.'
}, {
  name: 'Patricia S.',
  image: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=240&q=80',
  quote: 'Ya no discuto conmigo misma a las siete de la tarde. Sé qué voy a cenar.'
}, {
  name: 'Natalia B.',
  image: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?auto=format&fit=crop&w=240&q=80',
  quote: 'Cocino menos y como mejor. Recuperé un par de horas cada semana.'
}, {
  name: 'Fernanda L.',
  image: 'https://images.unsplash.com/photo-1534751516642-a1af1ef26a56?auto=format&fit=crop&w=240&q=80',
  quote: 'No lo siento como una dieta. Es simplemente mi forma de comer ahora.'
}];
const faqs = [['Casi no tengo tiempo, ¿me va a servir?', 'Sí. Está pensado justo para eso: decisiones rápidas, preparaciones cortas y una semana que se resuelve en pocos minutos.'], ['Ya intenté muchas veces y siempre lo dejo.', 'Es lo más común, y casi nunca es culpa tuya. Aquí no hay reglas imposibles: avanzas a tu ritmo y puedes retomar cuando quieras.'], ['No sé cocinar, ¿igual puedo hacerlo?', 'Sí. Todo está explicado paso a paso, con ingredientes normales. Si sabes usar una sartén, es suficiente.'], ['¿Y si fallo una semana?', 'No pasa nada. No se pierde el progreso ni hay que volver al inicio: simplemente abres tu guía y sigues desde donde estabas.'], ['¿Cuándo lo tengo y cómo lo veo?', 'En minutos, apenas confirmes tu compra. Te llega a tu correo y lo abres desde el celular, la tablet o la computadora.'], ['¿Necesito comprar cosas raras o caras?', 'No. Se usan ingredientes de cualquier supermercado, con alternativas para que adaptes lo que ya tienes en casa.']];
export function TrustFooter() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <>
      <section className="bg-[#fcfbf7] py-16 sm:py-20" data-id="element-355" data-mp="qxw71m6jtw3t">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-356" data-mp="r0s8hkhlv2x0">
          <motion.header initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.55
        }} className="mx-auto max-w-4xl text-center" data-id="element-357" data-mp="3qfdy42br2fu0">
            <p className="text-xs font-bold tracking-[0.22em] text-[#6d8063]" data-id="element-358" data-mp="1eqmg9nn2i1ae">
              NUNCA ESTÁS SOLA EN EL PROCESO
            </p>
            <h2 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-359" data-mp="3466w9gya759y">
              Cuatro compañeros para las distintas semanas de tu vida.
            </h2>
            <div className="mx-auto mt-8 max-w-3xl space-y-5 text-base leading-8 text-[#63705f] sm:text-lg" data-id="element-360" data-mp="2ufkno6ozff0r">
              <p data-id="element-361" data-mp="2phatnzezukgq">
                Hay semanas tranquilas y semanas imposibles. Cada pieza está
                pensada para una de ellas.
              </p>
              <p data-id="element-362" data-mp="2ld309oxlcgc6">
                Así, pase lo que pase, siempre tienes a dónde volver sin sentir
                que empiezas de nuevo.
              </p>
            </div>
          </motion.header>

          <motion.figure initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.65
        }} className="mx-auto mt-16 w-full max-w-6xl" data-id="element-363" data-mp="2bj2nr1zzc8tf">
            <img src="https://cdn.magicpatterns.com/uploads/dLbgVhcg6bmJHRqThEgKMo/ChatGPT_Image_17_jul_2026,_09_44_00.png" alt="Sistema Hábitos para una Vida Saludable con planificador nutricional, guía práctica, recetario déficit calórico y cocina antiinflamatoria" className="w-full rounded-2xl object-contain shadow-[0_16px_38px_rgba(64,72,53,0.11)]" data-id="element-364" data-mp="23x77lbcepyn7" />
          </motion.figure>

          <div className="mx-auto mt-16 grid max-w-6xl gap-5 sm:grid-cols-2" data-id="element-365" data-mp="2mv9yxwsfg7o6">
            {[['📗 TU PUNTO DE PARTIDA', 'Hábitos para una Vida Saludable', 'Para cuando no sabes por dónde empezar. Te da claridad y un primer paso posible, hoy mismo.'], ['🥗 RECETARIO DÉFICIT CALÓRICO', '', 'Para cuando quieres comer más ligero sin quedarte con hambre ni sentir que te castigas.'], ['🥬 COCINA ANTIINFLAMATORIA', '', 'Para cuando te cansas de lo mismo y necesitas sabores nuevos que te devuelvan las ganas.'], ['📅 PLANIFICADOR NUTRICIONAL', '', 'Para las semanas caóticas: decides una vez y el resto de los días fluyen solos.']].map(([eyebrow, title, copy], index) => <motion.article key={eyebrow} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.45,
            delay: index * 0.05
          }} className="rounded-2xl border border-[#e0e5da] bg-[#fffefa] p-7 shadow-[0_8px_22px_rgba(56,69,50,0.05)] sm:p-8" data-id="element-366" data-mp="6b7q2djf9q3g" data-mpi={index}>
                <p className="text-[11px] font-bold tracking-[0.14em] text-[#5d7655]" data-id="element-367" data-mp="336e3dg0828ri">
                  {eyebrow}
                </p>
                {title && <h3 className="font-display mt-4 text-2xl text-[#30452e]" data-id="element-368" data-mp="3c6ss6pcea5zr">
                    {title}
                  </h3>}
                <p className={`${title ? 'mt-3' : 'mt-4'} leading-7 text-[#63705f]`} data-id="element-369" data-mp="3m3fb38l5umz5">
                  {copy}
                </p>
              </motion.article>)}
          </div>

          <motion.aside initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.55
        }} className="mx-auto mt-12 max-w-6xl rounded-[22px] border border-[#d5e0ce] bg-[#edf3e8] p-7 sm:p-10" aria-labelledby="included-system-title" data-id="element-370" data-mp="3vti1r24t7oub">
            <h3 id="included-system-title" className="text-xs font-bold tracking-[0.2em] text-[#55704f]" data-id="element-371" data-mp="1k654t00o0bcn">
              TODO ESTO ES TUYO HOY
            </h3>
            <ul className="mt-7 grid gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-372" data-mp="2bw9k4k9ki870">
              {['Tu guía para empezar sin agobio', 'Recetario Déficit Calórico', 'Cocina Antiinflamatoria', 'Planificador Nutricional', 'Ideas para cuando no sabes qué hacer', 'Tus primeros 30 días resueltos', 'Menos tiempo cocinando entre semana', 'Smoothies para las mañanas apuradas', 'Jugos verdes que sí sabes preparar', 'Menús completos, sin pensar', 'Pequeños pasos que sí se sostienen', 'A mano en cualquier dispositivo', 'Lo abres hoy, no en unos días'].map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-6 text-[#4f614b]" data-id="element-373" data-mp="2e51065iiv6e0">
                  <CheckIcon className="mt-1 shrink-0 text-[#638359]" size={15} strokeWidth={2.3} aria-hidden="true" data-id="element-374" data-mp="2o141xa9gp30f" />
                  <span data-id="element-375" data-mp="2xqf8oq8vlvl5">{item}</span>
                </li>)}
            </ul>
          </motion.aside>

          <aside className="mx-auto mt-8 max-w-6xl rounded-[22px] border border-[#dae6d3] bg-[#f1f6ed] px-7 py-8 sm:px-10 sm:py-10" data-id="element-376" data-mp="2storu0p8yvyo">
            <h3 className="font-display text-2xl leading-tight text-[#395237] sm:text-3xl" data-id="element-377" data-mp="36psk3ogk8u8i">
              Se acabó el acumular consejos que nunca aplicas.
            </h3>
            <div className="mt-4 max-w-4xl space-y-3 leading-7 text-[#5a6b55]" data-id="element-378" data-mp="3lfdh5diqzu2t">
              <p data-id="element-379" data-mp="3qcvstbo5gnei">
                Abres, encuentras lo que necesitas y sigues con tu día. Sin
                buscar, sin dudar, sin postergarlo para el próximo lunes.
              </p>
            </div>
          </aside>

          <div className="mx-auto mt-12 max-w-5xl text-center" data-id="element-380" data-mp="3ge687b4vcouk">
            <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-16 w-full items-center justify-center rounded-full bg-[#3f603d] px-8 text-sm font-bold tracking-[0.07em] text-white shadow-[0_12px_24px_rgba(48,69,46,0.16)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304d30] hover:shadow-[0_16px_30px_rgba(48,69,46,0.22)]" data-id="element-381" data-mp="32o2qmxgxpjbg">
              QUIERO EMPEZAR SIN COMPLICARME
            </a>
            <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-3 text-xs font-medium text-[#5c6c57]" data-id="element-382" data-mp="2oobhpb59yt4b">
              <span data-id="element-383" data-mp="u8mjnndi8mcf">🔒 Pago 100% seguro</span>
              <span data-id="element-384" data-mp="uafsn9blbinl">⚡ Lo tienes en minutos</span>
              <span data-id="element-385" data-mp="phea8rc6d0z9">📥 Descarga digital</span>
              <span data-id="element-386" data-mp="pgbkwnui36lg">💚 Es tuyo para siempre</span>
              <span data-id="element-387" data-mp="ki1lg11qtju1">📱 En todos tus dispositivos</span>
            </div>
          </div>

          <div className="mx-auto mt-16 max-w-3xl text-center" data-id="element-388" data-mp="gh811hnien5w">
            <p className="font-display text-2xl leading-9 text-[#3f563b] sm:text-3xl" data-id="element-389" data-mp="geva4ezrx2gp">
              No necesitas una versión perfecta de ti. Solo una forma más amable
              de cuidarte.
            </p>
            <p className="mt-6 leading-8 text-[#62705f]" data-id="element-390" data-mp="186b6h0r4u3k4">
              Elegir algo mejor hoy. Preparar algo distinto mañana. Volver a
              empezar sin drama cuando haga falta. Así se sostiene el cambio.
            </p>
            <p className="font-display mt-7 text-2xl text-[#3f563b]" data-id="element-391" data-mp="3oxaxssd32rfg">
              Tu tranquilidad también merece un lugar.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#fcfbf7] pb-16 pt-10 sm:pb-20 sm:pt-12" data-id="element-392" data-mp="1zfw5ua8kt5ny">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-393" data-mp="1zdjg3awktr0c">
          <div className="grid gap-8 lg:grid-cols-[1.2fr_.8fr] lg:items-end" data-id="element-394" data-mp="24fsbedwx955m">
            <div data-id="element-395" data-mp="28fspfxg3zec5">
              <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-396" data-mp="28f9h98g9g4bb">
                HISTORIAS COMO LA TUYA
              </p>
              <h2 className="font-display mt-5 max-w-3xl text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-397" data-mp="2d95bq0xbf91q">
                Cuando comer deja de ser una lucha, todo lo demás se acomoda.
              </h2>
            </div>
            <div className="border-l-2 border-[#b3c3a8] pl-5 text-sm leading-7 text-[#667361] sm:pl-7" data-id="element-398" data-mp="2s4bi4p0bp9vl">
              <p data-id="element-399" data-mp="2w5n0c9gvastr">
                Cada proceso es distinto. Estas voces reflejan lo que más suele
                cambiar: la calma, el tiempo y las ganas de volver a la mesa.
              </p>
              <p className="mt-5 text-xs leading-5 text-[#7c8878]" data-id="element-400" data-mp="11rvw5phb515p">
                Comentarios representativos e ilustrativos de la comunidad; no
                corresponden a reseñas verificadas de compradores.
              </p>
            </div>
          </div>

          <div className="-mx-5 mt-14 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-5 md:mx-0 md:grid md:grid-cols-4 md:gap-5 md:overflow-visible md:px-0 md:pb-0" data-id="element-401" data-mp="2fua0869wdlt">
            {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.12
          }} transition={{
            duration: 0.42,
            delay: index % 4 * 0.05
          }} className="flex min-h-[290px] min-w-[278px] snap-start flex-col rounded-2xl border border-[#e1e4da] bg-[#fffefa] p-6 shadow-[0_9px_22px_rgba(56,69,50,0.06)] transition duration-300 md:min-w-0 md:hover:-translate-y-1 md:hover:shadow-[0_15px_30px_rgba(56,69,50,0.11)]" data-id="element-402" data-mp="3jwllygwz8o9u" data-mpi={index}>
                <div className="flex items-center justify-between gap-3" data-id="element-403" data-mp="12ok4ee02kqx2">
                  <img src={testimonial.image} alt={`Avatar ilustrativo de ${testimonial.name}`} className="h-11 w-11 rounded-full object-cover" data-id="element-404" data-mp="12mh8xeg5e5ky" />
                  <div className="flex text-[#a57d2a]" aria-label="5 de 5 estrellas" data-id="element-405" data-mp="1zf2xzy162txw">
                    {Array.from({
                  length: 5
                }).map((_, starIndex) => <StarIcon key={starIndex} fill="currentColor" size={13} data-id="element-406" data-mp="1qfzcyoifw4gr" data-mpi={starIndex} />)}
                  </div>
                </div>
                <blockquote className="mt-6 text-[15px] leading-7 text-[#4e5c4a]" data-id="element-407" data-mp="eyzo62vaw7rh">
                  “{testimonial.quote}”
                </blockquote>
                <p className="mt-auto border-t border-[#e5e7df] pt-5 text-sm font-semibold text-[#40533d]" data-id="element-408" data-mp="2gpzrt87tb9ex">
                  {testimonial.name}
                </p>
              </motion.article>)}
          </div>

          <aside className="mt-12 border border-[#d8e1d0] bg-[#eef3e9] px-7 py-8 sm:px-10 sm:py-9" aria-labelledby="decision-title" data-id="element-409" data-mp="22wqnhlyq1e39">
            <div className="flex flex-col gap-5 sm:flex-row sm:items-start" data-id="element-410" data-mp="1xvb1nropz3jt">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#fffefa] text-[#a57d2a] shadow-sm" aria-hidden="true" data-id="element-411" data-mp="1sxj7er0lr5cg">
                <StarIcon fill="currentColor" size={20} data-id="element-412" data-mp="1jz7ay8d21dc3" />
              </span>
              <div data-id="element-413" data-mp="3ic7m4ywo0zdn">
                <h3 id="decision-title" className="font-display text-3xl text-[#354a33]" data-id="element-414" data-mp="3icph7s7ld7jz">
                  Todo empieza con una decisión pequeña
                </h3>
                <p className="mt-4 max-w-4xl leading-7 text-[#586754]" data-id="element-415" data-mp="101s6vy7zq7p7">
                  No tienes que prometerte que nunca fallarás. Solo darte algo a
                  lo que volver cuando quieras cuidarte otra vez. Está listo
                  para cuando tú lo estés.
                </p>
              </div>
            </div>
          </aside>
        </div>
      </section>

      <section id="preguntas" className="bg-[#e9ebdf] py-16 sm:py-20" data-id="element-416" data-mp="h6lbivk9cda1">
        <div className="mx-auto grid max-w-6xl gap-12 px-5 sm:px-8 lg:grid-cols-[.7fr_1.3fr]" data-id="element-417" data-mp="m3brliw2b8vg">
          <div data-id="element-418" data-mp="q5ffj6zx45xm">
            <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-419" data-mp="q4nmo3xpgmb1">
              SIN LETRA PEQUEÑA
            </p>
            <h2 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-420" data-mp="v635rqgboiqs">
              Lo que quizá estás pensando
            </h2>
            <p className="mt-6 max-w-sm leading-7 text-[#62705e]" data-id="element-421" data-mp="26j5mqmmc3abh">
              Es normal dudar después de haberlo intentado tantas veces. Aquí
              van las respuestas, con toda la calma.
            </p>
          </div>
          <div className="border-t border-[#cfd5c7]" data-id="element-422" data-mp="1d9v1z1ifhni3">
            {faqs.map(([question, answer], index) => {
            const isOpen = openFaq === index;
            return <div key={question} className="border-b border-[#cfd5c7]" data-id="element-423" data-mp="1m7x79t9732b6" data-mpi={index}>
                  <button type="button" onClick={() => setOpenFaq(isOpen ? null : index)} className="flex w-full items-center justify-between gap-5 py-6 text-left font-medium text-[#384b36]" aria-expanded={isOpen} data-id="element-424" data-mp="20xcwv5wzp1pa">
                    <span data-id="element-425" data-mp="25y0o9sp4rkk1">{question}</span>
                    <ChevronDownIcon className={`shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-426" data-mp="25uuwu6t146l5" />
                  </button>
                  {isOpen && <div className="max-w-xl pb-6 leading-7 text-[#62705e]" data-id="element-427" data-mp="1erdz3mi7ipv">
                      {answer}
                    </div>}
                </div>;
          })}
          </div>
        </div>
      </section>

      <FinalOffer data-id="element-428" data-mp="3nuc7bfvm84jc" />

      <footer className="bg-[#263624] px-5 py-12 text-[#d8e1d0] sm:px-8" data-id="element-429" data-mp="3stp2cnwn4hx0">
        <div className="mx-auto max-w-7xl" data-id="element-430" data-mp="3sruize10oxv1">
          <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between" data-id="element-431" data-mp="3dvwpy4me49n1">
            <div data-id="element-432" data-mp="3iv97qayemqir">
              <p className="text-xs font-bold tracking-[0.18em] text-white" data-id="element-433" data-mp="3ivrcxx31of2t">
                CÓDIGO FITNESS™
              </p>
              <p className="mt-4 max-w-xs text-sm leading-6" data-id="element-434" data-mp="34xaytl2urman">
                “Pequeños cambios diarios pueden transformar toda una vida.”
              </p>
            </div>
            <nav className="flex flex-wrap gap-x-6 gap-y-3 text-xs" aria-label="Enlaces legales" data-id="element-435" data-mp="135emwacrwafc">
              <a href="/politica-de-privacidad" className="transition-colors hover:text-white" data-id="element-436" data-mp="181dh4eks8mno">
                Política de Privacidad
              </a>
              <a href="/terminos-y-condiciones" className="transition-colors hover:text-white" data-id="element-437" data-mp="2ggfkq6z1f48d">
                Términos y Condiciones
              </a>
              <a href="/politica-de-reembolsos" className="transition-colors hover:text-white" data-id="element-438" data-mp="26mglbfqclyk4">
                Política de Reembolsos
              </a>
              <a href="/descargo-de-responsabilidad" className="transition-colors hover:text-white" data-id="element-439" data-mp="2zb48jgunqy0b">
                Descargo de Responsabilidad
              </a>
            </nav>
          </div>

          <div className="mt-10 border-t border-[#719061]/30 pt-7" data-id="element-440" data-mp="19y0tte3ohf4d">
            <p className="max-w-4xl text-xs leading-6 text-white/75" data-id="element-441" data-mp="1dzvtke5ynkg1">
              Al completar tu compra aceptas nuestros Términos y Condiciones.
              Debido a la naturaleza digital de este producto y al acceso
              inmediato a todos los archivos descargables, no se aceptan
              devoluciones, cambios ni reembolsos una vez confirmada la compra.
            </p>
            <p className="mt-5 text-xs text-white/75" data-id="element-442" data-mp="1gc6ej2wdecdm">
              © 2026 Código Fitness™. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>
    </>;
}